import React from 'react';

const PlannerSessionFields = ({ formData, setFormData, mode, handleSubmit }) => (
  <form onSubmit={handleSubmit}>
    <label>Session ID:</label>
    <input
      type="text"
      value={formData.session_id}
      onChange={(e) => setFormData({ ...formData, session_id: e.target.value })}
      required
      disabled={mode === 'edit'}
    /><br />

    <label>Proposed Change Name:</label>
    <input
      type="text"
      value={formData.proposed_change_name}
      onChange={(e) => setFormData({ ...formData, proposed_change_name: e.target.value })}
    /><br />

    <label>Draft Scope:</label><br />
    <textarea
      rows="5"
      cols="60"
      value={formData.draft_scope}
      onChange={(e) => setFormData({ ...formData, draft_scope: e.target.value })}
    /><br />

    <button type="submit">{mode === 'create' ? 'Create Session' : 'Update Session'}</button>
  </form>
);

export default PlannerSessionFields;
